import { CMS_CUSTOMER_PLAN_FALLBACK } from './cms-customer-plan-fallback.const';
import { CMS_HOMEPAGE_FALLBACK } from './cms-homepage-fallback.const';
import { CMS_MANAGE_TRIPS_FALLBACK } from './cms-manage-trips-fallback.const';

export const CMS_FALLBAK_TEMPLATES_DICT = {
  '/home': CMS_HOMEPAGE_FALLBACK,
  '/home/manage-trips': CMS_MANAGE_TRIPS_FALLBACK,
  '/home/customer-assurance/customer-service-plan': CMS_CUSTOMER_PLAN_FALLBACK,
};
